/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#main[dir=ltr]{width:35%;left:35%}@media screen and (min-width:0){#main[dir=ltr]{width:100%;left:0}}@media screen and (min-width:1024px){#main[dir=ltr]{width:35%!important;left:35%!important}}"];
export { styles as styles };
